import { Component, inject } from '@angular/core';
import { ConfirmationDialogComponent } from '../confirmation-dialog.component';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { LocalChangesConfirmationModalConfig, NotificationModelWithModalConfig } from '../../notification/notification.model';
import { NotificationType } from '../../notification/notification-type.enum';
import _ from 'lodash';

@Component({
    selector: 'adm4-local-changes-confirmation-dialog',
    template: `
    <adm4-modal-dialog-title [ngClass]='options.style'
      [header]="data.notificationMessage.headerTitle || options.header"
      [showClose]="!dialogRef.disableClose"
      (closeClicked)="closeDialog()">
      <div mat-dialog-content class="content-container">
        <span class="title">{{data.notificationMessage.title}}</span><br>
        <div class="description">
          @if (isInfoDialog) {
            @if (projectKey) {
              <adm4-local-changes-project-info-dialog [projectKey]='projectKey' (closeDialog)='closeDialog(true)'></adm4-local-changes-project-info-dialog>
            }
          } @else {
            @if (projectKey) {
              <adm4-local-changes-project-confirmation-dialog [projectKey]='projectKey'></adm4-local-changes-project-confirmation-dialog>
            }
            @if (inventoryKey) {
              <adm4-local-changes-inventory-confirmation-dialog [inventoryKey]='inventoryKey'></adm4-local-changes-inventory-confirmation-dialog>
            }
            @if (concurrentChange) {
              <adm4-concurrent-changes-inventory-confirmation-dialog (triggerInventoryRefresh)='triggerAction()'></adm4-concurrent-changes-inventory-confirmation-dialog>
            }
          }
        </div>
      </div>
      <mat-dialog-actions>
        @if (!isInfoDialog) {
          <button class='admn4-button-text' (click)='closeDialog(false)'>{{cancelButtonText}}</button>
        }
        <button class='admn4-button-ellipse-default' (click)="closeDialog(true)">{{confirmButtonText}}</button>
      </mat-dialog-actions>
    </adm4-modal-dialog-title>
    `,
    styleUrls: ['../modal-dialog-notification.component.scss'],
    standalone: false
})
export class LocalChangesConfirmationDialogComponent extends ConfirmationDialogComponent {
  override dialogRef: MatDialogRef<LocalChangesConfirmationDialogComponent>;
  override data: NotificationModelWithModalConfig<LocalChangesConfirmationModalConfig>;


  projectKey?: string;
  inventoryKey?: string;
  concurrentChange?: boolean;

  constructor() {
    const dialogRef = inject<MatDialogRef<LocalChangesConfirmationDialogComponent>>(MatDialogRef);
    const data = inject<NotificationModelWithModalConfig<LocalChangesConfirmationModalConfig>>(MAT_DIALOG_DATA);

    super();
    this.dialogRef = dialogRef;
    this.data = data;


    this.projectKey = data.modalConfig.projectKey;
    this.inventoryKey = data.modalConfig.inventoryKey;
    this.concurrentChange = data.modalConfig.concurrentChange;
  }

  triggerAction(): void {
    if (_.isFunction(this.data.modalConfig.onSaveCallback)) {
      this.data.modalConfig.onSaveCallback();
    }
    this.closeDialog();
  }

  get isInfoDialog(): boolean {
    return _.isEqual(this.data.type, NotificationType.DIALOG_INFO);
  }
}
